/* eslint-disable import/prefer-default-export */

import { RCompostionFoyerStandardSchema_Type } from '@batical/types/src'
import { fetchGeneric } from './GenericQ'

const RCompostionFoyerStandard: Array<RCompostionFoyerStandardSchema_Type> = require('../json/CompositionFoyerStandard.json')

export function fetchRCompostionFoyerStandard(uuid: string): RCompostionFoyerStandardSchema_Type {
  return fetchGeneric(RCompostionFoyerStandard, uuid)
}
